import {format as dateFormat, parseISO} from 'date-fns';
import {de} from 'date-fns/locale';
import {toZonedTime} from 'date-fns-tz';

export const formatMinutesAsDuration = (minutes: number): string => {
  const hours = minutes / 60;
  const completeHours = Math.floor(hours);
  const remainingMinutes = Math.round((hours - completeHours) * 60);

  return `${completeHours}h ${remainingMinutes}min`;
};

export const formatMinutesAsTime = (m: number): string => {
  const quotient = m / 60;
  const hours = Math.trunc(quotient);
  const hoursPadded = hours.toString().padStart(2, '0');
  const minutes = Math.round((quotient % 1) * 60);
  const minutesPadded = minutes.toString().padStart(2, '0');

  return `${hoursPadded}:${minutesPadded}`;
};

export const safeDateFormat = (
  date: string,
  format: string,
  {
    fallback = '',
    utc = false,
    ...options
  }: {fallback?: string; utc?: boolean} = {}
): string => {
  try {
    const dateParsed = parseISO(date);
    const dateToFormat = utc ? toZonedTime(dateParsed, 'UTC') : dateParsed;

    return dateFormat(dateToFormat, format, {
      ...options,
      locale: de,
    });
  } catch {
    return fallback;
  }
};
